import TyListItem from './TyListItem.vue'
export default TyListItem



// WEBPACK FOOTER //
// ./src/components/ty-listitem/index.js